import { Mesh } from 'three';
import React from 'react';

const defaultFontSize = 12;
const defaultColor = '#000000';

export default {
    name: 'elevation-sign',
    prototype: 'items',

    info: {
        tag: ['elevation-sign'],
        title: 'Elevation Sign',
        description: 'Elevation Sign',
        image: require('./elevation-sign.png')
    },

    properties: {
        text: {
            label: 'text',
            type: 'string',
            defaultValue: ''
        },
        fontSize: {
            label: 'font size',
            type: 'number',
            defaultValue: defaultFontSize
        },
        color: {
            label: 'text color',
            type: 'color',
            defaultValue: defaultColor
        },
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 75
            }
        },
        showFloorElevation: {
            label: 'Show floor elevation',
            type: 'checkbox',
            defaultValue: true,
            values: {
                'none': false,
                'yes': true
            }
        }
    },

    render2D: function (element, layer, scene) {
        let color = element.properties.get('color') || defaultColor;
        let text = element.properties.get('text') || '';
        let fontSize = element.properties.get('fontSize') || defaultFontSize;
        let width = element.properties.get('width').get('length');
        let showFloorElevation = element.properties.get('showFloorElevation');

        let elevationText = '';

        if (element.floorID) {
            let floorsArr = [];
            let floors = scene.get('floors').toJS();

            if (floors) {
                for (var floor in floors) {
                    floorsArr.push(floors[floor]);
                }
            }

            let elementFloor = floorsArr.find(f => f.id === element.floorID);

            if (elementFloor) {
                if (elementFloor.elevation === 0) {
                    elevationText = `${elementFloor.elevation / 100}m`;
                } else {
                    elevationText = elementFloor.elevation > 0 ? `+${elementFloor.elevation / 100}m` : `${elementFloor.elevation / 100}m`;
                }
            }
        }

        return (
            <g transform={`scale(${width * 0.02} ${width * 0.02}) translate(-10, 7)`}>
                <path id="1" d="M0 0 H75 0" style={{ stroke: '#000000' }} />
                <path id="2" d="M16 16 L16 -16" style={{ stroke: '#000000' }} />
                <path id="3" d="M16,0 L8,0  A8,8 0 0,1    16,-8 z"
                    style={{ fill: "#000000", stroke: '#000000' }} />
                <path id="4" d="M16,0 L16,8 A8,8 0 0,1 8,0 z"
                    style={{ fill: "#ffffff", stroke: '#000000' }} />
                <path id="5" d="M16,0 L24,0 A8,8 0 0,1 16,8  z"
                    style={{ fill: "#000000", stroke: '#000000' }} />
                <path id="6" d="M16,0 L16,-8  A8,8 0 0,1  24,000  z"
                    style={{ fill: "#ffffff", stroke: '#000000' }} />

                <text
                    x="27"
                    y="-5"
                    fontFamily="Arial"
                    alignmentBaseline="start"
                    textAnchor=""
                    fontSize={fontSize}
                    fill={color}
                    transform={'scale(1,-1)'}
                >
                    {showFloorElevation ? `${text ? text + ' ' : ''}${elevationText}` : text}
                </text>
            </g>

        )


    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
